import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { server } from '../app/conf'
@Injectable({
  providedIn: 'root'
})
export class ComponentService {
  constructor(private http: HttpClient) { }
  findAllComponents() {
    return this.http.get<any[]>(`${server}components`);
  }
  findAComponent(_id: string) {
    return this.http.get<any>(`${server}components/${_id}`);
  }
  findAComponentForCde(_id: string, accessToken, serialNumber) {
    return this.http.get<any>(`${server}componentsforcde/${_id}/${serialNumber}
    ?access_token=${accessToken}`);
  }
  createComponent(component) {
    return this.http.post<any>(`${server}components`, component);
  }
  updateComponent(_id: string, component) {
    return this.http.put<any>(`${server}components/${_id}`, component);
  }
  deleteComponent(_id: string) {
    return this.http.delete(`${server}components/${_id}`);
  }

  getGapDataForTable(case_id: string) {
    return this.http.get<any>(`${server}gapvfnforcde/getEmploymentGapData/${case_id}`)
  }
}
